import Header from "../components/layout/Header"
import Footer from "../components/layout/Footer"
import HeroSection from "../components/home/HeroSection"
import CategorySection from "../components/home/CategorySection"
import ProductSection from "../components/home/ProductSection"
// @ts-ignore
import PromotionBanner from "../components/home/PromotionBanner"
import { getActiveBanners } from "@/api/bannerApi.ts"
import { useEffect, useState } from "react"
import { getPublicProducts } from "@/api/productApi.ts"
import NewProductSlider from "@/components/home/NewProductSlider"

export default function MainPage() {
    const [heroBanners, setHeroBanners] = useState<any[]>([])
    // @ts-ignore
    const [promoBanners, setPromoBanners] = useState<any[]>([])

    const [bestProducts, setBestProducts] = useState<any[]>([])
    const [mainProducts, setMainProducts] = useState<any[]>([])

    useEffect(() => {
        const fetchData = async () => {
            const heroRes = await getActiveBanners("HERO")
            const promoRes = await getActiveBanners("PROMO")
            setHeroBanners(heroRes.data || [])
            setPromoBanners(promoRes.data || [])

            // 💡 1. 베스트 상품 호출 (BEST 배지 강제 추가)
            const bestRes = await getPublicProducts({
                size: 10,
                // sort: "createdAt,desc",
                sort: "sortOrder,asc",
                bestYn: "Y"
            })
            let bestItems = bestRes.data?.items || bestRes.data?.data?.items || bestRes.data || []
            if (!Array.isArray(bestItems)) bestItems = []

            // 모든 베스트 상품에 'BEST' 배지 노출
            bestItems = bestItems.map((item: any) => ({ ...item, badge: 'BEST' }))
            setBestProducts(bestItems)

            // 💡 2. 일반 메인 노출 상품 호출 (BEST 배지 제거)
            const mainRes = await getPublicProducts({
                size: 20,
                // sort: "createdAt,desc",
                sort: "sortOrder,asc",
                mainExposureYn: "Y"
            })
            let mainItems = mainRes.data?.items || mainRes.data?.data?.items || mainRes.data || []
            if (!Array.isArray(mainItems)) mainItems = []

            // 'BEST' 배지가 있다면 숨김 처리 (단, 'HOT' 등 다른 배지가 있다면 유지)
            mainItems = mainItems.map((item: any) => ({
                ...item,
                badge: item.badge === 'BEST' ? null : item.badge
            }))
            setMainProducts(mainItems)
        }
        fetchData()
    }, [])

    return (
      <div className="min-h-screen bg-white text-slate-900">
          <Header />

          <main>
              <section className="w-full">
                  <HeroSection banners={heroBanners} />
              </section>

              <div className="bg-slate-50 py-8">
                  <CategorySection />
              </div>

              {/* 💡 3. 베스트 상품 영역 */}
              {bestProducts.length > 0 && (
                <div className="bg-slate-50 pt-8 pb-4">
                    <NewProductSlider
                      title="베스트 상품"
                      subtitle="현재 고객님들이 가장 많이 찾는 인기 상품입니다."
                      products={bestProducts}
                    />
                </div>
              )}

              {/* 💡 4. 지금 인기있는 상품 영역 */}
              <div className="pt-8 pb-12">
                  <ProductSection
                    title="지금 인기있는 상품"
                    subtitle="정성껏 준비한 메인 노출 인기 상품들을 만나보세요."
                    products={mainProducts}
                  />
              </div>
          </main>

          <Footer />
      </div>
    )
}